import Column from '@components/column'
import Row from '@components/row'
import CardHeading from '@commons/headings/card'
import Search from '@commons/search'
import { InstituteLabTest } from '@apis'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import LabTestCard from '@commons/cards/labTest'
import ScrollView from '@commons/scroll'
import { StyleRefWrapper } from './style'
import LabTestCardLoader from '@commons/cards/labTest/loader'
import Empty from '@commons/empty'
import useInfinityScroll from '@hooks/useInfinityScroll'
const initalParams = {
  page: 1,
  limit: 12,
  isPackage: false,
  search: '',
}
const LabTests = ({ packages, onAdd, id }: any) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const { data: user } = useSelector((state: any) => state.user)
  const {
    items: labTests,
    loading,
    totalPages,
  } = useSelector((state: any) => state.searchInstituteLabTests)

  const [params, setParams] = useState<any>({
    ...initalParams,
    userId: user?.id,
  })

  const fetchData = async (params, action = 'set') => {
    await InstituteLabTest.list({
      params,
      state: 'searchInstituteLabTests',
      action,
    }).catch(() => {})
  }

  const loadMore = async () => {
    const updateParams = {
      ...params,
      page: params?.page + 1,
    }
    if (updateParams.page <= totalPages) {
      await fetchData(updateParams, 'append')
      setParams(updateParams)
    }
  }

  const { observeTarget }: any = useInfinityScroll({
    loading,
    hasMore: params?.page < totalPages ? true : false,
    onLoadMore: loadMore,
    rootRef: scrollContainerRef,
  })

  const handleSearch = async (search) => {
    const updateParams = {
      ...initalParams,
      search,
    }
    setParams(updateParams)
    await fetchData(updateParams)
  }

  const handleClick = async (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-id]')
    if (!!cross) {
      const id = cross.getAttribute('data-cross-id')
      const labTest = labTests?.find((labTest: any) => labTest.id == id)
      if (!!labTest?.id) {
        onAdd?.(labTest)
      }
    }
  }

  useEffect(() => {
    if (!labTests?.length && !id) {
      fetchData(params)
    }
  }, [])
  return (
    <Column
      bg="white"
      styleColumn="border-radius:12px;padding:15px 20px;"
      rowGap={20}
    >
      <Row justifyContent="space-between" alignItems="center">
        <CardHeading title="Our Lab Tests" tc={'primary'} />
        <Search onSubmit={handleSearch} />
      </Row>
      <ScrollView onClick={handleClick} ref={scrollContainerRef}>
        {!!loading && !id ? (
          <>
            {Array(6)
              ?.fill(0)
              ?.map((_: any, index) => {
                return (
                  <Fragment key={index}>
                    <LabTestCardLoader />
                  </Fragment>
                )
              })}
          </>
        ) : (
          <>
            {!!labTests?.length || !!id ? (
              <>
                {(!!id ? packages : labTests)?.map((labTest: any, index) => {
                  const isAdded = packages?.findIndex(
                    (item: any) => item?.id == labTest?.id,
                  )
                  const shouldObserve = index === labTests.length - 1
                  return (
                    <StyleRefWrapper
                      key={labTest?.id}
                      ref={shouldObserve ? observeTarget : null}
                    >
                      <LabTestCard
                        labTest={labTest}
                        title={isAdded > -1 ? 'Added' : 'Add to Package'}
                        outline={isAdded > -1 ? true : false}
                      />
                    </StyleRefWrapper>
                  )
                })}
              </>
            ) : (
              <Empty />
            )}
          </>
        )}
      </ScrollView>
    </Column>
  )
}

export default LabTests
